/**
 * Die Kopfzeile. Steht auf jeder Seite und hat genau eine Pflicht: einen
 * Weg zurueck. Vorher gab es keinen sichtbaren Nachhauseweg, und das ist
 * bei einem Spiel, in das man ueber einen Code oder einen QR faellt, die
 * erste Frage.
 *
 * Schlank: Wortmarke links (fuehrt heim), ein paar Wege rechts. Auf der
 * Startseite steht der grosse Titel ohnehin, darum ist die Kopfzeile dort
 * nur der Rahmen und nicht doppelt.
 */
import { Link, useLocation } from 'react-router-dom'

import { loadSession } from '../lib/api'
import { useLang } from '../lang'

export function Header() {
  const { lang } = useLang()
  const de = lang === 'de'
  const { pathname } = useLocation()
  const sitzung = loadSession()
  const rollen = sitzung?.roles ?? []
  const darfVerwalten = rollen.includes('admin') || rollen.includes('manager')
  const angemeldet = Boolean(sitzung) && sitzung?.is_guest === false

  return (
    <header className="topbar">
      <Link to="/" className="topbar__home" aria-label={de ? 'Zur Startseite' : 'Home'}>
        <span className="topbar__mark">BB<span className="dot">.</span></span>
        <span className="topbar__word">Bullshit Bingo</span>
      </Link>
      <nav className="topbar__nav">
        <Link to="/wand" aria-current={pathname === '/wand' ? 'page' : undefined}>
          {de ? 'Wand' : 'Wall'}
        </Link>
        <Link to="/regeln" aria-current={pathname === '/regeln' ? 'page' : undefined}>
          {de ? 'Regeln' : 'Rules'}
        </Link>
        <Link to="/konto" aria-current={pathname === '/konto' ? 'page' : undefined}>
          {angemeldet ? (de ? 'Konto' : 'Account') : de ? 'Anmelden' : 'Sign in'}
        </Link>
        {darfVerwalten ? (
          <Link to="/verwaltung" className="topbar__admin" aria-current={pathname.startsWith('/verwaltung') ? 'page' : undefined}>
            {de ? 'Verwaltung' : 'Admin'}
          </Link>
        ) : null}
      </nav>
    </header>
  )
}
